import { render, staticRenderFns } from "./help-recent-menu.vue?vue&type=template&id=9d39281e&scoped=true"
import script from "./help-recent-menu.vue?vue&type=script&lang=js"
export * from "./help-recent-menu.vue?vue&type=script&lang=js"
import style0 from "./help-recent-menu.vue?vue&type=style&index=0&id=9d39281e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d39281e",
  null
  
)

export default component.exports